import { Button, Modal } from "@shapr3d/frontend-lib";
import { useParams } from "react-router-dom";

import { useMutateProjectViewLink } from "../../hooks/useProjectViewLink";
import { useTracker } from "../../hooks/useTracker";
import type { LinkListTelemetryLocation } from "../LinkList/LinkList";

import style from "./UnpublishConfirmationModal.module.css";

export const UnpublishConfirmationModal = ({
  open,
  onClose,
  viewLinkId,
  telemetryLocation,
}: {
  open: boolean;
  onClose: () => void;
  viewLinkId: string;
  telemetryLocation: LinkListTelemetryLocation;
}) => {
  const { teamID } = useParams();
  const tracker = useTracker();
  const { mutate, error, isPending } = useMutateProjectViewLink({ teamID, onSuccess: onClose });

  return (
    <Modal open={open} onClose={onClose} size="small" title="Unpublish link">
      <div className={style.modalContainer}>
        <div>
          Are you sure you want to unpublish this link? This will remove access for all members.
        </div>
        <Button
          disabled={isPending}
          variant="red"
          onClick={() => {
            tracker.trackUnpublishConfirmed({
              activeTeamId: String(teamID),
              viewLinkId: viewLinkId,
              type: "view_link",
              location: telemetryLocation,
            });
            mutate({ viewLinkId, body: { sharedState: "not_shared" } });
          }}
        >
          Unpublish link
        </Button>
        {error && (
          <div className={style.errorMessage}>
            <span>Something went wrong. Please try again.</span>
          </div>
        )}
      </div>
    </Modal>
  );
};
